export const DISCOVER_PAGE_SIZE = 24;
export const DISCOVER_RELOAD_MS = 2000;
export const DISCOVER_LOAD_MORE_SKELETON_COUNT = 2;
